<div class="{{key.parentClass}}" *ngFor="let key of legendData; trackBy: trackByIndex">
  <div class="legend__item {{key.childClass}}"><app-icon iconName="{{key.iconName}}"></app-icon></div>
  <div class="legend__item {{key.textClass}}">{{key.text}}</div>
</div>